import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getAttributes } from '../actions/AttributeActions';
import DataTable from '../../common/DataTable/DataTable';
import { Link } from 'react-router-dom';
import { Button, Pane } from 'evergreen-ui';

class ListAttributes extends Component {
    handleTableChange = (opts) => {
        this.props.dispatch(getAttributes(opts));
    }

    render() {
        return (<>
            <Pane display="flex" marginBottom={16}>
                <Pane>
                    <Link to="/attributes/create">
                        <Button iconBefore="add" intent="none" appearance="primary">
                            Atribut nou
                        </Button>
                    </Link>
                </Pane>
            </Pane>
            <DataTable
                defaultFilter='id'
                defaultDirection='desc'
                columns={[
                    {id: 'id', label: 'Id'},
                    {id: 'name', label: 'Nume'},
                    {id: 'type', label: 'Tip'},
                    {id: 'createdAt', label: 'Creat', decorator: 'date'},
                    {id: 'updatedAt', label: 'Updated', decorator: 'date'}
                ]}

                data={this.props.data}
                updateKey={this.props.data}
                page={this.props.page}
                pageSize={this.props.pageSize}
                pageCount={this.props.pageCount}

                onTableChange={this.handleTableChange}

                itemMenu={[
                    { getLink: (item) => `/attributes/${item[0]}`, label: 'Detalii', icon: 'eye-open' },
                    { getLink: (item) => `/attributes/${item[0]}/edit`, label: 'Editeaza', icon: 'edit' }
                ]}
            />
        </>)
    }
}

function mapStateToProps(state) {
    return state.attributes;
}

export default connect(mapStateToProps)(ListAttributes);